
export const types={
    authCheckingFinish: '[auth] Finish checking login state',
    authStartLogin: '[auth] Start Login',
    authLogin: '[auth] Login',
    authLogout: '[auth] Logout',

    eventSetActive:'[event] Set Active',
    eventClearActiveEvent: '[event] Clear active event',

    productosMDFLoaded:'[event] Productos MDF loaded',
    productosVinilLoaded:'[event] Productos vinil loaded',
    productosCajasLoaded:'[event] Productos cajas loaded',

    productoCaja:'[event] Productos caja loaded'

}